mutation DeleteMoneyPageAction($input: UrlAutomationDeleteInput!) {
    maUrlAutomationDelete(input: $input) {
        automation {
            id
            actions {
                id
                type
                position
            }
        }
    }
}
